import BankToken from '@apps/finance/admin/tokens/bank'
import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class Edit extends React.Component {

  static contextTypes = {
    modal: PropTypes.object
  }

  static propTypes = {
    id: PropTypes.number
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form {...this._getForm()} />
  }

  _getForm() {
    const { id } = this.props
    return {
      title: 't(Edit Program)',
      method: 'PATCH',
      endpoint: `/api/admin/team/programs/${id}/edit`,
      action: `/api/admin/team/programs/${id}`,
      onCancel: this._handleCancel,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            { label: 't(Title)', name: 'title', type: 'textfield', required: true },
            { label: 't(Logo)', name: 'logo_id', type: 'attachmentfield', multiple: false, allow: { extensions: ['jpg','jpeg','png','gif'] } },
            { label: 't(Bank)', name: 'bank_id', type: 'lookup', endpoint: '/api/admin/finance/banks', filter: { status: { $eq: 'active' } }, valueKey: 'id', textKey: 'title', format: BankToken },
            { label: 't(Invoice Address)', name: 'address', type: 'textarea', rows: 2 }
          ]
        }
      ]
    }
  }

  _handleCancel() {
    this.context.modal.close()
  }

  _handleSuccess() {
    this.context.modal.close()
  }

}

export default Edit
